module.exports = __webpack_public_path__ + "static/media/question-mark-circle.e5c929e7.svg";